import { createSelector } from '@ngrx/store';

import { selectTrailersState } from '@store/trailers/trailers.state';

/**
 * Селектор для получения последнего состояния вкладки с прицепами.
 */
export const selectLastStateTrailersPage = createSelector(
  selectTrailersState,
  (state) => state.lastPageState,
);

/**
 * Селектор для получения последнего состояния списка с прицепами.
 */
export const selectLastStateOnTabTrailersList = createSelector(
  selectLastStateTrailersPage,
  (state) => state.list,
);

/**
 * Селектор для получения состояния загрузки списка прицепов.
 */
export const selectListTabLoading = createSelector(
  selectLastStateOnTabTrailersList,
  (state) => state?.loading || false,
);

/**
 * Селектор для получения последнего состояния списка групп с прицепами.
 */
export const selectLastStateOnTabTrailersGroups = createSelector(
  selectLastStateTrailersPage,
  (state) => state.groups,
);

/**
 * Селектор для получения состояния загрузки списка групп с прицепами.
 */
export const selectGroupsTabLoading = createSelector(
  selectLastStateOnTabTrailersGroups,
  (state) => state?.loading || false,
);
